import { Esg_Category } from '@graphql/generated/graphql';

/** Theme / UI keys (palette.esg, icons) — the three ESG pillars only. */
export type CategoryName = 'environmental' | 'social' | 'governance';

/**
 * Maps API {@link Esg_Category} to UI keys. GENERAL, STANDARDS, etc. have no
 * dashboard stats equivalent — returns null for those.
 */
const ESG_CATEGORY_TO_UI: Partial<Record<Esg_Category, CategoryName>> = {
    ENVIRONMENTAL: 'environmental',
    GOVERNANCE: 'governance',
    SOCIAL: 'social',
};

export const mapEsgCategoryToUiCategory = (
    category: Esg_Category,
): CategoryName | null => ESG_CATEGORY_TO_UI[category] ?? null;
